<template>
    <div>
        <v-card dark elevation="10" class="rounded-lg" v-if="!quickAccessData" transition="fade-in">
            <v-card-title>
                    <span class="text-h5 font-weight-medium">Acessos Rápidos</span>
            </v-card-title>
            <v-card-text>
                <v-sheet class="d-flex justify-center">
                    <div class="text-body-1 font-weight-regular">
                        <span>Acessos Rápidos trazem mais organização para seu fluxo de trabalho.</span>
                    </div>
                </v-sheet>
            </v-card-text>
            <v-card-actions>
                <v-btn block color="green darken-2" elevation="10" class="rounded-lg" @click="$emit('addQuickAccess')">
                    <span class="text-overline font-weight-medium">
                        Configurar 
                    </span>
                    <v-icon right >
                    mdi-cog
                    </v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-btn v-else color="grey darken-4" elevation="2" class="rounded-lg pa-5 mx-2 mb-4 white--text" :to="{name: quickAccessData.name}">
            <span class="text-overline font-weight-medium">{{quickAccessData.title}}</span>
            <v-icon right medium class="ml-3" color="#b71c1c">{{quickAccessData.icon}}</v-icon>
        </v-btn>
    </div>
</template>

<script>
export default {
    props:{
        quickAccessData: {
            type: Object,

        }
    }
}
</script>

<style>
.texto-vermelho-escuro {
  color: #b71c1c;
}
</style>